<hf-custom-spinner *ngIf="initialized && isLoading" [sidepaneLoading]="true"></hf-custom-spinner>
